(function () {
  function handleSwatchClick(e) {
    var swatch = e.target.closest('.product-card-custom__swatch');
    if (!swatch) return;
    e.preventDefault();

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    var newSrc = swatch.getAttribute('data-variant-image');
    if (!newSrc) return;

    var wrapper = card.querySelector('.product-card-custom__image');
    if (!wrapper) return;

    var img = wrapper.querySelector('img');
    if (!img) return;

    // Clear srcset so the browser doesn't keep picking the old image.
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', newSrc);
    img.src = newSrc;

    // Update active state.
    card.querySelectorAll('.product-card-custom__swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  }

  document.addEventListener('click', handleSwatchClick);
})();
